/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const completeSignupFields = {
  name: {
    required: true,
  },
  password: {
    required: true,
  },
  company: {
    required: true,
  },
};

export function storeSessionDetails(details) {
  if (!details || typeof details !== "object" || !details.userId) {
    return null;
  }
  const sessionData = {
    companyname: details.companyName,
    companyuuid: details.companyId,
    customerAccountStatus: details.companyAccountStatus,
    customerAccountType: details.companyAccountType,
    roleName: details.roleName,
    user_id: details.userId,
  };

  localStorage.setItem("session_details", JSON.stringify(sessionData));
  localStorage.setItem("company-status", details.companyAccountStatus);

  return sessionData;
}
